module.exports = "<div class=rm-middle-toolbar ng-transclude=\"\"></div>";